<template>
  <div>
    <ul class="formList">
      <text-input-form
          description="고객명을 확인하시고 입력해주세요."
          :data="item.customerName">
        <text-input :data="item.customerName" :disable="item.customerName.disabled" @change="validate"/>
      </text-input-form>

      <text-input-form
          description="최초등록일 년월일 8자리를 확인하시고 입력해주세요."
          :data="item.vehicleRegDate">
        <text-input :data="item.vehicleRegDate" :type="'number'" :disable="item.vehicleRegDate.disabled" @change="validate"/>
      </text-input-form>

      <text-input-form
          description="자동차등록번호를 확인하시고 입력해주세요."
          :data="item.vehicleRegNum">
        <text-input :data="item.vehicleRegNum" :disable="item.vehicleRegNum.disabled" @change="validate"/>
      </text-input-form>

      <text-input-form
          description="형식 & 모델연도를 확인하시고 입력해주세요."
          :col="2"
          :data="item.model" :data-add="item.modelYear">
        <text-input :data="item.model" :disable="item.model.disabled" @change="validate"/>
        <text-input :data="item.modelYear" :type="'number'" :disable="item.modelYear.disabled" @change="validate"/>
      </text-input-form>

      <text-input-form
          :data="item.vehicleNumId">
        <text-input :data="item.vehicleNumId" :max="17" :disable="item.vehicleNumId.disabled" @change="validate"/>
      </text-input-form>
    </ul>
    <ul class="listDot mgt">
      <li>차량 명의자가 변경 된 경우 서비스센터에 방문하시어 명의자 변경을 신청하셔야 차량 등록이 정상적으로 이루어집니다.</li>
    </ul>
  </div>
</template>

<script>

import Const from '../../../helpers/Const'
import TextInput from "../../../components/Input/TextInput";
import TextInputForm from '../../../components/Input/TextInputForm.vue';
import SubscApplyVehicleConst from './SubscApplyVehicleConst' ;

export default {
  components:{
    TextInput,
    TextInputForm,
  },

  create() {
  },

  props: {
    item: SubscApplyVehicleConst.ITEM,
    validated: Boolean,
  },

  data() {
    return {
      done: false,
      v: this.item.customerName.validate &&
          this.item.vehicleRegDate.validate &&
          this.item.vehicleRegNum.validate &&
          this.item.model.validate &&
          this.item.modelYear.validate &&
          this.item.vehicleNumId.validate,
    }
  },

  watch: {
    'item.model.val': {
      handler (val) {
        if(this.item.model.val) {
          this.item.model.val = val.toUpperCase().replace(Const.REG_EXP_SPECIAL, "");
        }
      },
    },
    'item.vehicleNumId.val': {
      handler (val) {
        if(val) {
          this.item.vehicleNumId.val = val.toUpperCase().replace(Const.REG_EXP_SPECIAL, "");
        }
      },
    },
    'item.vehicleRegNum.val': {
      handler (val) {
        if(this.item.vehicleRegNum.val) {
          this.item.vehicleRegNum.val = val.replace(Const.REG_EXP_SPECIAL, "");
        }
      },
    },
  },

  computed: {
  },


  methods: {
    setItem(item){
      this.item = item;
    },

    validate() {
      let validated =
          this.item.customerName.validate &&
          this.item.vehicleRegDate.validate &&
          this.item.vehicleRegNum.validate &&
          this.item.model.validate &&
          this.item.modelYear.validate &&
          this.item.vehicleNumId.validate;
      this.$emit('validated', validated);
    },

  }

}
</script>
